import { IMessageId } from "infrastructure/localization";
import { INotification } from "infrastructure/notification";

export interface IToken {
  id: string;
  name: string;
  type: string;
  originalType: string;
  description: string;
  value?: any;
  displayValue?: any;
  customToken?: boolean;
}

export interface IMessageResponse {
  messageId: string;
  text: string;
  status: string;
  tokens: IToken[];
  version: number;
}

export interface IMessageRequest {
  messageId: string;
  tokens: IToken[];
  text: string;
}

export interface IValidationResult {
  success: boolean;
  errorMessageId?: IMessageId;
  tokens?: {};
}

export interface ITokenValidationResult {
  tokenId: string;
  descriptionRequired: boolean;
  tokenNameRequired: boolean;
  duplicateTokenName: boolean;
  invalidTokenType: boolean;
  isValid: boolean;
}

export interface ITokenDescriptionValidationResult {
  [key: string]: ITokenValidationResult;
}

export interface IMessageIdState {
  messageId: string;
  messageIdValidationError: string;
  text: string;
  textValidationError: string;
  descriptionsValidationErrors: ITokenDescriptionValidationResult;
  currentStatus: string;
  version: number;
  tokens: IToken[];
  textPreview: string;
  notifications: INotification[];
  isLoading: boolean;
  shouldRedirect: boolean;
  redirectPath: string;
}

export const getMessageIdInitialState = (): IMessageIdState => {
  return {
    messageId: "",
    messageIdValidationError: "",
    text: "",
    textValidationError: "",
    version: 0,
    descriptionsValidationErrors: {},
    currentStatus: "",
    tokens: [],
    textPreview: "",
    notifications: [],
    isLoading: false,
    shouldRedirect: false,
    redirectPath: ""
  };
};
